import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { map } from 'rxjs'

@Component({
  selector: `eld-error`,
  styleUrls: [`./error.component.scss`],
  templateUrl: `./error.component.html`
})
export class ErrorComponent {
  protected error$ = this.activatedRoute.queryParams.pipe(
    map(({ error }) => error)
  )

  constructor (private activatedRoute: ActivatedRoute) {}
}
